import React from 'react'

const ScalePointIcon = (options = {}) => {
  // flexShrink as per the defaultRenderPointer
  return (
    <svg
      width="8"
      height="8"
      viewBox="0 0 8 8"
      style={{ flexShrink: 0 }}
    >
      <circle cx="4" cy="4" r="4" fill="#045781"></circle>
    </svg>
  )
}

export default ScalePointIcon
